import Vue from 'vue'

import moment from 'moment'

export default Vue.extend({
  name: 'Announcement',

  props: {
    loading: {
      type: Boolean as Prop<boolean>
    },
    announcements: {
      type: Array as Prop<model.Announcement[]>
    }
  },

  filters: {
    formatDate (val: string): string {
      return moment(val).format('YYYY/MM/DD')
    }
  },

  methods: {
    handleClickAnnouncement (target: model.Announcement) {
      this.$emit('click', target)
    }
  }
})
